// Heros

// Components
import PersonalForm from '@/components/insurance/PersonalForm.vue';
import verifyNumber from '@/components/insurance/VerifyNumber.vue';
import verifyCode from '@/components/insurance/VerifyCode.vue';
import AdditionalQuestions from '@/components/insurance/AdditionalQuestions.vue';
import HomeAddress from '@/components/insurance/turborater/HomeAddress.vue';
import QuoteToc from '@/components/insurance/QuoteToC.vue';

// Views
import ErrorPage from '@/views/shared/ErrorPageV2.vue';
import Disclaimer from '@/views/insurance/Disclaimer.vue';
import Quotes from '@/views/insurance/Quote.vue';
import RedirectRoute from '@/components/RedirectEntryRoute.vue';

export default [
  {
    path: '',
    component: RedirectRoute,
    meta: {
      skipImpression: true,
    },
  },
  {
    path: 'error',
    name: 'insurance-error-mobile',
    component: ErrorPage,
    meta: {
      headerIcon: 'home',
      navInfo: false,
      errorPayload: {
        buttonText: 'returnHome',
      },
    },
  },
  {
    path: 'disclaimer',
    name: 'insurance-disclaimer-mobile',
    component: Disclaimer,
    meta: {
      navInfo: false,
      numberOfSteps: 1,
      headerIcon: 'home',
      hideSelectText: true,
    },
  },
  {
    path: 'termsConditions',
    name: 'termsConditions-mobile',
    component: QuoteToc,
    meta: {
      navInfo: false,
      numberOfSteps: 1,
      headerIcon: 'back',
      hideSelectText: true,
    },
  },
  {
    path: 'insurance-application',
    name: 'insurance-application-mobile',
    component: {
      render(h) {
        return h('router-view');
      },
    },
    children: [
      {
        path: 'personalform',
        name: 'insurance-personal-form-mobile',
        component: PersonalForm,
        meta: {
          navInfo: {
            from: 0,
            to: 1,
          },
          numberOfSteps: 6,
          headerIcon: 'back',
        },
      },
      {
        path: 'mobile-verification',
        name: 'insurance-mobile-verification-mobile',
        component: verifyNumber,
        meta: {
          navInfo: {
            from: 1,
            to: 2,
          },
          numberOfSteps: 6,
          headerIcon: 'back',
        },
      },
      {
        path: 'verification-code',
        name: 'insurance-mobile-code-mobile',
        component: verifyCode,
        meta: {
          navInfo: {
            from: 2,
            to: 3,
          },
          numberOfSteps: 6,
          headerIcon: 'back',
        },
      },
      {
        path: 'home-address',
        name: 'home-address-mobile',
        component: HomeAddress,
        meta: {
          navInfo: {
            from: 3,
            to: 4,
          },
          numberOfSteps: 6,
          headerIcon: 'back',
        },
      },
      {
        path: 'additionalquestions',
        name: 'additional-questions-mobile',
        component: AdditionalQuestions,
        meta: {
          navInfo: {
            from: 4,
            to: 5,
          },
          numberOfSteps: 6,
          headerIcon: 'back',
        },
      },
      {
        path: 'quotes',
        name: 'quotes-mobile',
        component: Quotes,
        meta: {
          navInfo: false,
          numberOfSteps: 5,
          headerIcon: 'home',
        },
      },
    ],
  },
];
